import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import _ from 'lodash-es';
import { SearchCompaniesResult } from '../sections/company-search/models/search-companies-result.model';
import { CompanyDetails } from '../sections/company-drill-down/models/company-details.model';
import { Financial } from '../../models/financial.model';
import { BusinessDescription } from '../../models/business-description.model';
import { CompanyInfo } from '../../models/company-info.model';

@Injectable()
export class CompanyService {
  constructor(private http: HttpClient) {}

  public searchCompanies(payload): Observable<SearchCompaniesResult> {
    return this.http.post<SearchCompaniesResult>('/api/companies/searchcompanies/', payload) as Observable<SearchCompaniesResult>;
  }

  public getCompanyDetails(
    studyId: number,
    searchStrategyId: number,
    comparableId: number,
    databaseId: number,
    feedId: number,
    databaseIds: number[],
    filingTypeId?: number
  ): Observable<CompanyDetails> {
    const ids = _.join(databaseIds, '&dbIds=');
    return this.http.get<CompanyDetails>(
      `/api/companies/details?studyId=${studyId}&searchStrategyId=${searchStrategyId}&comparableId=${comparableId}&databaseId=${databaseId}&feedId=${feedId}&dbIds=${ids}${this.filigTypeIdParam(
        filingTypeId
      )}`
    );
  }

  public getIndustryDescriptions(
    searchStrategyId: number,
    uniqueId: number,
    databaseId: number,
    feedId: number,
    filingTypeId?: number
  ): Observable<string[]> {
    return this.http.get<string[]>(
      `/api/companies/industrydescriptions?searchStrategyId=${searchStrategyId}&uniqueId=${uniqueId}&databaseId=${databaseId}&feedId=${feedId}${this.filigTypeIdParam(
        filingTypeId
      )}`
    );
  }

  public getCompanyInfo(
    searchStrategyId: number,
    uniqueId: number,
    databaseId: number,
    feedId: number,
    filingTypeId?: number
  ): Observable<CompanyInfo> {
    return this.http.get<CompanyInfo>(
      `/api/companies/companyinfo?searchStrategyId=${searchStrategyId}&uniqueId=${uniqueId}&databaseId=${databaseId}&feedId=${feedId}${this.filigTypeIdParam(
        filingTypeId
      )}`
    );
  }

  public getBusinessDescription(
    searchStrategyId: number,
    uniqueId: number,
    databaseId: number,
    feedId: number,
    filingTypeId?: number
  ): Observable<BusinessDescription> {
    return this.http.get<BusinessDescription>(
      `/api/companies/businessdescription?searchStrategyId=${searchStrategyId}&uniqueId=${uniqueId}&databaseId=${databaseId}&feedId=${feedId}${this.filigTypeIdParam(
        filingTypeId
      )}`
    );
  }

  public getFinancial(
    studyId: number,
    searchStrategyId: number,
    uniqueId: number,
    databaseId: number,
    feedId: number,
    consolidated: boolean,
    functionalCurrency: boolean,
    filingTypeId?: number
  ): Observable<Financial> {
    return this.http.get<Financial>(
      `/api/companies/financial?studyId=${studyId}&searchStrategyId=${searchStrategyId}&uniqueId=${uniqueId}&databaseId=${databaseId}&feedId=${feedId}&consolidated=${consolidated}&functionalCurrency=${functionalCurrency}${this.filigTypeIdParam(
        filingTypeId
      )}`
    );
  }

  public getCompaniesFilingType(searchStrategyId: number, comparableIds: number[]): Observable<any> {
    const ids = _.join(comparableIds, '&ids=');
    return this.http.get<any>(`/api/companies/filingtype?searchStrategyId=${searchStrategyId}&ids=${ids}`);
  }

  private filigTypeIdParam(filingTypeId?: number) {
    return filingTypeId === null ? '' : `&filingTypeId=${filingTypeId}`;
  }
}
